import React, {Fragment} from 'react';
import {Route, Routes} from "react-router";
import IngredientsListView from "../organisms/IngredientsListView";
import {RecipeForm} from "../organisms/RecipeForm/RecipeForm";
import {RecipesListView} from "../organisms/RecipesListView";
import {RecipeConverterForm} from "../organisms/RecipeConverterForm/RecipeConverterForm";

function Body() {
    return (
        <Fragment>
            <div className="body-wrapper">
                <div className="background-image"/>
                <div className="body">
                    <Routes>
                        <Route path='/' element={null}/>
                        <Route path='/point4' element={null}/>
                        <Route path="/ingredients" element={<IngredientsListView/>}/>
                        <Route path="/recipes" element={<RecipesListView/>}/>
                        <Route path="/recipes/add" element={<RecipeForm mode={"add"}/>}/>
                        <Route path="/recipes/edit/:recipe" element={<RecipeForm mode={"edit"}/>}/>
                        <Route path="/recipes/converter/:recipe" element={<RecipeConverterForm/>}/>
                    </Routes>
                </div>
            </div>
        </Fragment>

    );
}

export default Body;
